interface CleanupSchedule {
  enabled: boolean;
  staleDays: number;
}

export enum MaterializationFormat {
  CSV = 'csv',
  MORAWA_SK = 'csv/morawa',
  JSON = 'json',
  JSON_BOB = 'json/bob',
  ENFORE = 'json/enfore',
  JSON_TCHIBO = 'json/tchibo',
  POS_LOG_HEINEMANN = 'poslog/heinemann',
  POS_LOG_STOREWEAVER = 'poslog/storeweaver',
  SCALEDATA_TEEGSCHWENDNER = 'scaledata/teegschwendner',
  ORGASOFT = 'bahlsen/orgasoftreceipt',
}

export enum SinkType {
  Storage = 'storage',
  RESTService = 'rest',
  SoapService = 'soap',
  Orgasoft = 'orgasoft',
  FiscalCloudArchive = 'fiscal-cloud-archive',
  HttpUsingJwtToken = 'http-jwt-token',
  Shopify = 'shopify',
}

export interface SinkConfiguration {
  type: SinkType;
  endpoint?: string; // rest, soap, fiscal-cloud-archive
  action?: string; // soap
  username?: string; // rest, soap, fiscal-cloud-archive
  password?: string; // rest, soap, fiscal-cloud-archive
  tokenUrl?: string; // rest, fiscal-cloud-archive
}

export enum TransactionKind {
  Sale = 'sale',
  VoidSale = 'voidSale',
  Closing = 'closing',
  CustomerPayment = 'customerPayment',
}

interface MaterializationConfiguration {
  format: MaterializationFormat;
  sink: SinkConfiguration;
  kinds?: TransactionKind[];
}

export enum LogFormat {
  AGGREGATED_RECEIPT = 'aggregated_receipts',
  DFKA_TAXONOMIE = 'dfka_taxonomie_2023_03',
  DSFINVK = 'dsfinvk_2023_03',
  RECEIPT_ARCHIVE = 'receipt_archive',
  CSV = 'csv/transactions',
  CSV_ALDI = 'csv/aldi-sued',
  TCHIBO = 'day_end/tchibo',
  TEGUT = 'daily_totals/tegut',
  POSLOG_STOREWEAVER = 'poslog/storeweaver',
  POSLOG_TEGUT = 'poslog/tegut',
  SK_MORAWA = 'sk/morawa',
  SRS_EGECKO = 'srs/egecko',
  VTK_SOLD = 'vtksold/morawa',
  STRAUSS_ACCOUNTING = 'strauss/accounting',
}

export type ClosingLogSinks = Partial<Record<LogFormat, SinkConfiguration>>;

export interface TransactionConfig {
  id: string;
  allowedVoidDuration?: string;
  materializations: MaterializationConfiguration[];
  closingLogSinks?: ClosingLogSinks;
  includeNonFinalOrders: boolean;
  cleanupSchedule: CleanupSchedule;
  closingLogFormats?: string[];
}
